import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_SYSTEM_API)

/**
 * 获取表格配置
 */
export function getTableConfig(type, data) {
  return request.post(`account/ui/display/${type}/list`, data)
}

/**
 * 保存表格配置
 */
export function batchSaveTableConfig(type, data) {
  return request.post(`account/ui/display/${type}/batchSave`, data)
}
